/**
 * Formats a date string according to the user's locale
 * @param dateString - The date string to format
 * @returns Formatted date string in the user's locale format
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  
  // Get user's locale from browser
  const userLocale = navigator.language || 'en-US';
  
  // Format options for date
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  
  return new Intl.DateTimeFormat(userLocale, options).format(date);
};

/**
 * Formats a date string with time according to the user's locale
 * @param dateString - The date string to format
 * @returns Formatted date and time string in the user's locale format
 */
export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  
  // Get user's locale from browser
  const userLocale = navigator.language || 'en-US';
  
  // Format options for date and time
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  
  return new Intl.DateTimeFormat(userLocale, options).format(date);
}; 